// extracted by mini-css-extract-plugin
module.exports = {"link":"ConfirmationModal__link___3wLdr"};